export default "__VITE_ASSET__CEkb4Lqs__"